/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * MovingWorlds API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  AdminIntroduction,
  GetAdminIntroductionCountParams,
  GetIntroductionsParams,
  HTTPValidationError,
  UpdateOutcomeRequest,
} from './platformapi.schemas';

import getIntroductionsMutator from '../custom-axios-instance';
import getAdminIntroductionCountMutator from '../custom-axios-instance';
import updateIntroductionOutcomeMutator from '../custom-axios-instance';

/**
 * Reteives all introductions
 * @summary Get Introductions
 */
export const getIntroductions = (params: GetIntroductionsParams, signal?: AbortSignal) => {
  return getIntroductionsMutator<AdminIntroduction[]>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/introductions/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetIntroductionsQueryKey = (params: GetIntroductionsParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/introductions/`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetIntroductionsQueryOptions = <
  TData = Awaited<ReturnType<typeof getIntroductions>>,
  TError = void | HTTPValidationError,
>(
  params: GetIntroductionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntroductions>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIntroductionsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIntroductions>>> = ({ signal }) =>
    getIntroductions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getIntroductions>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetIntroductionsQueryResult = NonNullable<Awaited<ReturnType<typeof getIntroductions>>>;
export type GetIntroductionsQueryError = void | HTTPValidationError;

export function useGetIntroductions<
  TData = Awaited<ReturnType<typeof getIntroductions>>,
  TError = void | HTTPValidationError,
>(
  params: GetIntroductionsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntroductions>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntroductions>>,
          TError,
          Awaited<ReturnType<typeof getIntroductions>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetIntroductions<
  TData = Awaited<ReturnType<typeof getIntroductions>>,
  TError = void | HTTPValidationError,
>(
  params: GetIntroductionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntroductions>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIntroductions>>,
          TError,
          Awaited<ReturnType<typeof getIntroductions>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetIntroductions<
  TData = Awaited<ReturnType<typeof getIntroductions>>,
  TError = void | HTTPValidationError,
>(
  params: GetIntroductionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntroductions>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Introductions
 */

export function useGetIntroductions<
  TData = Awaited<ReturnType<typeof getIntroductions>>,
  TError = void | HTTPValidationError,
>(
  params: GetIntroductionsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getIntroductions>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetIntroductionsQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieves the total number of introductions after filter
 * @summary Get Admin Introduction Count
 */
export const getAdminIntroductionCount = (
  params?: GetAdminIntroductionCountParams,
  signal?: AbortSignal,
) => {
  return getAdminIntroductionCountMutator<number>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/introductions/count`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetAdminIntroductionCountQueryKey = (params?: GetAdminIntroductionCountParams) => {
  return [
    `${import.meta.env['VITE_API_HOST']}/admin/introductions/count`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAdminIntroductionCountQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminIntroductionCount>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminIntroductionCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminIntroductionCount>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminIntroductionCountQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminIntroductionCount>>> = ({
    signal,
  }) => getAdminIntroductionCount(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminIntroductionCount>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetAdminIntroductionCountQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminIntroductionCount>>
>;
export type GetAdminIntroductionCountQueryError = void | HTTPValidationError;

export function useGetAdminIntroductionCount<
  TData = Awaited<ReturnType<typeof getAdminIntroductionCount>>,
  TError = void | HTTPValidationError,
>(
  params: undefined | GetAdminIntroductionCountParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminIntroductionCount>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminIntroductionCount>>,
          TError,
          Awaited<ReturnType<typeof getAdminIntroductionCount>>
        >,
        'initialData'
      >;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAdminIntroductionCount<
  TData = Awaited<ReturnType<typeof getAdminIntroductionCount>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminIntroductionCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminIntroductionCount>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminIntroductionCount>>,
          TError,
          Awaited<ReturnType<typeof getAdminIntroductionCount>>
        >,
        'initialData'
      >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetAdminIntroductionCount<
  TData = Awaited<ReturnType<typeof getAdminIntroductionCount>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminIntroductionCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminIntroductionCount>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get Admin Introduction Count
 */

export function useGetAdminIntroductionCount<
  TData = Awaited<ReturnType<typeof getAdminIntroductionCount>>,
  TError = void | HTTPValidationError,
>(
  params?: GetAdminIntroductionCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAdminIntroductionCount>>, TError, TData>
    >;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetAdminIntroductionCountQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Updates the outcome of an introduction
 * @summary Update Introduction Outcome
 */
export const updateIntroductionOutcome = (
  updateOutcomeRequest: UpdateOutcomeRequest,
  signal?: AbortSignal,
) => {
  return updateIntroductionOutcomeMutator<unknown>({
    url: `${import.meta.env['VITE_API_HOST']}/admin/introductions/update-outcome`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: updateOutcomeRequest,
    signal,
  });
};

export const getUpdateIntroductionOutcomeMutationOptions = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateIntroductionOutcome>>,
    TError,
    { data: UpdateOutcomeRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateIntroductionOutcome>>,
  TError,
  { data: UpdateOutcomeRequest },
  TContext
> => {
  const mutationKey = ['updateIntroductionOutcome'];
  const { mutation: mutationOptions } =
    options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
        options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateIntroductionOutcome>>,
    { data: UpdateOutcomeRequest }
  > = (props) => {
    const { data } = props ?? {};

    return updateIntroductionOutcome(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateIntroductionOutcomeMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateIntroductionOutcome>>
>;
export type UpdateIntroductionOutcomeMutationBody = UpdateOutcomeRequest;
export type UpdateIntroductionOutcomeMutationError = void | HTTPValidationError;

/**
 * @summary Update Introduction Outcome
 */
export const useUpdateIntroductionOutcome = <
  TError = void | HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateIntroductionOutcome>>,
    TError,
    { data: UpdateOutcomeRequest },
    TContext
  >;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateIntroductionOutcome>>,
  TError,
  { data: UpdateOutcomeRequest },
  TContext
> => {
  const mutationOptions = getUpdateIntroductionOutcomeMutationOptions(options);

  return useMutation(mutationOptions);
};
